
import moment from 'moment'
import { Component } from 'vue-property-decorator'
import FiltersMixin from '@/modules/insight/mixins/FiltersMixin.vue'

@Component({ mixins: [FiltersMixin] })
export default class AdFilters extends FiltersMixin {
  filtersType = 'ad'
  adName = ''
  adId = ''
  effectiveStatus = ''

  statuses = [
    { key: 'Active', value: 'ACTIVE' },
    { key: 'Paused', value: 'PAUSED' },
    { key: 'Deleted', value: 'DELETED' },
    { key: 'Pending Review', value: 'PENDING_REVIEW' },
    { key: 'Disapproved', value: 'DISAPPROVED' },
    { key: 'Preapproved', value: 'PREAPPROVED' },
    { key: 'Pending Billing Info', value: 'PENDING_BILLING_INFO' },
    { key: 'Campaign Paused', value: 'CAMPAIGN_PAUSED' },
    { key: 'Archived', value: 'ARCHIVED' },
    { key: 'Adset paused', value: 'ADSET_PAUSED' },
    { key: 'In Process', value: 'IN_PROCESS' },
    { key: 'With Issues', value: 'WITH_ISSUES' }
  ]

  initialParams = {
    adName: '',
    adId: '',
    effectiveStatus: '',
    start: this.formatDate(moment().subtract(1, 'day')),
    end: this.formatDate(moment())
  }

  paramsField = 'adParams'
  updateAction = 'insight/updateAdInsights'
  setFilterAction = 'insight/setAdParams'
  getAction = 'insight/getAds'

  created() {
    this.adName = this.params.adName
    this.adId = this.params.adId
    this.effectiveStatus = this.params.effectiveStatus
  }
}
